import * as angular from "angular";
import {IController, IScope} from "angular";
import {ConsolidatedCommissionModel} from "../../models/consolidated-commission.model";

export class ConsolidatedCommissionsTableRowCtrl implements IController {

  consolidatedCommissionId: string;
  isSelected: any;
  onSelect: Function;
  onView: Function;
  onMarkAsPaid: Function;
  onPay: Function;
  onAttachFile: Function;
  onExportCsv: Function;
  onEdit: Function;
  onDelete: Function;

  public consolidatedCommission: ConsolidatedCommissionModel;

  constructor(private IAMPermissions, private $consolidatedCommission, private $scope: IScope) {
  }

  $onInit() {
    if (this.consolidatedCommissionId) {
      this.$consolidatedCommission(this.consolidatedCommissionId).$bindCtrlToId(this.$scope, this, 'consolidatedCommission', 'consolidatedCommissionId');
    }
  }

  $onChanges(changes) {
    if(changes.consolidatedCommissionId && !changes.consolidatedCommissionId.isFirstChange()){
      this.$onInit();
    }
  }

}

angular
  .module('bringoz.admin.commissions')
  .component('consolidatedCommissionsTableRow', {
    require: {
      consolidatedCommissionsTableCtrl: '^consolidatedCommissionsTable'
    },
    bindings: {
      consolidatedCommissionId: '<',
      isSelected: '<?',
      onSelect: '&',
      onView: '&',
      onMarkAsPaid: '&',
      onPay: '&',
      onAttachFile: '&',
      onExportCsv: '&',
      onEdit: '&',
      onDelete: '&'
    },
    template: require('./consolidated-commissions-table-row.html').default,
    controller: ConsolidatedCommissionsTableRowCtrl
  });
